/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_BarcodeInputs */

const vi_product_barcode = /** @type {(inputs: Product_BarcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã vạch`)
};

/**

* @param {Product_BarcodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_barcode = /** @type {((inputs?: Product_BarcodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_BarcodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_barcode(inputs)
});